/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Expected_CloseInputs */

const cs_deals_expected_close = /** @type {(inputs: Deals_Expected_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávané uzavření`)
};

const en_deals_expected_close = /** @type {(inputs: Deals_Expected_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected close`)
};

/**
* | output |
* | --- |
* | "Expected close" |
*
* @param {Deals_Expected_CloseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_expected_close = /** @type {((inputs?: Deals_Expected_CloseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Expected_CloseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_expected_close(inputs)
	return cs_deals_expected_close(inputs)
});